import { useStore } from "@/hooks/useStore";
import { Panel, PageTitle } from "@/components/ui/Panel";
import { StringList } from "@/components/ui/StringList";
import type { ReferenceData } from "@/types/reference";

const FIELDS: { key: keyof Omit<ReferenceData, "glossary">; label: string }[] = [
  { key: "sets", label: "Sets" },
  { key: "factions", label: "Factions" },
  { key: "championTypes", label: "Champion types" },
  { key: "rarities", label: "Rarities" },
  { key: "keywords", label: "Keywords" },
  { key: "mechanics", label: "Mechanic tags" },
  { key: "utilityTypes", label: "Utility types" },
  { key: "equipmentSubtypes", label: "Equipment subtypes" },
  { key: "secondarySubtypes", label: "Secondary subtypes" },
  { key: "weaponTypes", label: "Weapon types" },
];

export function ReferenceDataPage() {
  const { state, setState } = useStore();
  const ref = state.referenceData;

  function update(key: keyof ReferenceData, value: string[]) {
    setState((s) => ({ ...s, referenceData: { ...s.referenceData, [key]: value } }));
  }

  return (
    <div className="space-y-4">
      <PageTitle>Reference Data</PageTitle>
      <p className="text-sm text-[#64748b]">
        These lists feed dropdowns across the editor. Glossary lives on its own page.
      </p>
      <div className="grid gap-3 md:grid-cols-2">
        {FIELDS.map((f) => (
          <Panel key={f.key}>
            <h3 className="font-display text-sm font-semibold mb-2">{f.label}</h3>
            <StringList value={ref[f.key]} onChange={(v) => update(f.key, v)} />
          </Panel>
        ))}
      </div>
    </div>
  );
}
